import { User } from "features/panelManagement/accessManagement/types/access";
import { MultilingualString } from "./string";

export type InfoAdapter = DefaultInfo | StringInfo;

export enum InfoAdapterType {
    StringInfo = "StringInfo",
    DefaultInfo = "DefaultInfo",
}

// Simple string info
export interface StringInfo {
    type: InfoAdapterType.StringInfo;
    value: string;
}

// Log info
export type Log = TimeInfoFields & {
    userInfo?: {
        uid: User["uid"];
    };
    eventInfo?: {
        description: string;
    };
};

// Default info
export type DefaultInfo = DefaultInfoFields & {
    type: InfoAdapterType.DefaultInfo;
};

type DefaultInfoFields = DescriptiveInfoFields &
    TimeInfoFields &
    AnalyticsInfoFields &
    LinkedInfoFields &
    VisibilityInfoFields;

// Have separated default info into blocks for better modularity
interface DescriptiveInfoFields {
    name?: MultilingualString;
    description?: MultilingualString;
    qtyUnit?: MultilingualString;
    image?: string;
}

interface TimeInfoFields {
    creationTimestamp?: number;
    updateTimestamp?: number; // when it was last updated
}

interface AnalyticsInfoFields {
    seo?: string;
    rank?: number;
    categoryRank?: number; // for manually sorting category
    viewCount?: number;
}

interface LinkedInfoFields {
    linkedArticleId?: string; // link to the article
}

interface VisibilityInfoFields {
    isHidden?: boolean;
}
